module.exports = __webpack_public_path__ + "static/media/terra.a76d4132.png";